import * as types from "../../../actions/systemlevel/index";

export default function(state = [], action) {
  switch (action.type) {
    case types.FETCH_THIRD_PARTY_PAYEE_PAYMENT_TYPE:
      return action.payload.data;
    default:
      return state;
  }
}
